import React from 'react';
import styled from 'astroturf/react';
import AvatarBase from 'js/social/shared/Avatar';
import _AvatarContainer from "OverlappingAvatars-AvatarContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/OverlappingAvatars.tsx?styleId=AvatarContainer";
import _Avatar from "OverlappingAvatars-Avatar.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/OverlappingAvatars.tsx?styleId=Avatar";


const AvatarContainer = /*#__PURE__*/styled("div", null, {
  displayName: "AvatarContainer",
  styles: _AvatarContainer
});

const Avatar = /*#__PURE__*/styled(AvatarBase, null, {
  displayName: "Avatar",
  styles: _Avatar
});

export type OverlappingAvatarUser = {
  id: number;
  displayName: string;
  photo: string;
  url?: string;
};

type Props = {
  size?: number;
  users: OverlappingAvatarUser[];
  disableLinks?: boolean;
};

export const OverlappingAvatars: React.FC<Props> = ({
  size = 24,
  users,
  disableLinks = false,
}) => {
  if (users.length <= 0) {
    return null;
  }

  return (
    <AvatarContainer>
      {users.map((user) => (
        <Avatar
          key={user.id}
          style={{ '--size': `${size}px` } as React.CSSProperties}
          fullName={user.displayName}
          photoUrl={user.photo}
          profileUrl={disableLinks ? undefined : user.url}
        />
      ))}
    </AvatarContainer>
  );
};
